import React, { Fragment } from "react";
import { Table } from "react-bulma-components";
import { colors, COLORS } from "../../constants";
import { countries } from "country-data";
import { convDJConst, displayCurrency, renderDateCalender } from "../../utils";
import moment from "moment";

const JobDetailsTable = ({ job, showBounty = true }) => {
	if (!job) {
		return null;
	}
	const minSalary = job.minSalary ? displayCurrency(job.minSalary, job.salaryCurrency) : null;

	const maxSalary = job.maxSalary ? displayCurrency(job.maxSalary, job.salaryCurrency) : null;

	return (
		<Table bordered={false} className="is-hoverable" striped={false}>
			<tbody>
				<tr>
					<td>Job title</td>
					<td>{job.headline}</td>
				</tr>
				{showBounty && (
					<Fragment>
						<tr>
							<td>Bounty</td>
							<td>{displayCurrency(job.bounty, job.bountyCurrency)}</td>
						</tr>
						{job.bounty > 0 && (
							<tr>
								<td>Bounty currency</td>
								<td>{job.bountyCurrency}</td>
							</tr>
						)}
					</Fragment>
				)}
				{job.location && (
					<tr>
						<td>Work location</td>
						<td>
							{job.location.streetAddress}
							<br />
							{countries[job.location.country].name} - {job.location.postalCode}
						</td>
					</tr>
				)}
				{job.applicantCountry && (
					<tr>
						<td>Visa/Work permit</td>
						<td>Applicant must be eligible to work in {countries[job.applicantCountry].name}</td>
					</tr>
				)}
				{job.showSalary ? (
					<Fragment>
						<tr key={"salary"}>
							<td>Salary</td>
							<td>
								{job.maxSalary > job.minSalary ? `${minSalary} - ${maxSalary}` : minSalary}{" "}
								{job.payUnit && `/ ${job.payUnit.toLowerCase()}`}
							</td>
						</tr>
						<tr key={"salaryCurrency"}>
							<td>Salary currency</td>
							<td>{job.salaryCurrency}</td>
						</tr>
					</Fragment>
				) : (
					<tr key={"salary"}>
						<td>Salary</td>
						<td>As per industry standards</td>
					</tr>
				)}

				{job.expiry && (
					<tr>
						<td>Applications closing date</td>
						<td>{renderDateCalender(job.expiry)}</td>
					</tr>
				)}
				<tr>
					<td>Option to work remotely</td>
					<td>{job.isRemote ? "Yes" : "No"}</td>
				</tr>
				<tr>
					<td>Type</td>
					<td>{convDJConst(job.employmentType)}</td>
				</tr>
				<tr>
					<td>Last updated</td>
					<td>{renderDateCalender(job.updated)}</td>
				</tr>
			</tbody>
		</Table>
	);
};

export default JobDetailsTable;
